import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import { Effect } from 'formik-effect'
import SOPQFlightsSearchForm from './SOPQFlightsSearchForm'
import withSOPQFlightState from './withSOPQFlightState'
import withValidation from './withValidation'
import { validateSOPQFlightsSchema } from './validateSOPQFlights'
const StatefulForm = withSOPQFlightState(withValidation(SOPQFlightsSearchForm))
const noop = () => {}

class SOPQFlightFormContainer extends React.Component {
  static defaultProps = {
    mapper: validateSOPQFlightsSchema,
    errors: {},
    onChange: noop,
    onSubmit: noop,
    validate: noop,
    validateOnChange: false,
    validateOnBlur: false
  }

  static propTypes = {
    render: PropTypes.func,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    validate: PropTypes.func,
    update: PropTypes.func,
    handleCalendarChange: PropTypes.func,
    closeSOPQCalendar: PropTypes.func
  }

  /**
   * This func is only used when a renderProp, render method is provided else this is handled in #withSOPQFlightState
   * @param options
   */
  handleCalendarChange = options => {
    const areBothDatesAvail = options.dates.startDate && options.dates.endDate
    const {
      onChange,
      handleCalendarChange,
      update,
      closeSOPQCalendar
    } = this.props

    if (!options.isOneWay) {
      onChange({
        departureDate: options.dates.startDate,
        arrivalDate: options.dates.endDate
      })

      if (handleCalendarChange) {
        handleCalendarChange({
          departureDate: options.dates.startDate,
          arrivalDate: options.dates.endDate
        })
      }
    } else if (options.isOneWay) {
      onChange({
        departureDate: options.dates.startDate
      })

      if (handleCalendarChange) {
        handleCalendarChange({
          departureDate: options.dates.startDate
        })
      }
    }

    if (options.isOneWay || areBothDatesAvail) {
      update(closeSOPQCalendar)
    }
  }

  render () {
    const { render, onChange, ...props } = this.props
    const renderProps = {
      ...props,
      ...this.state,
      ...this.handleCalendarChange
    }

    if (render) {
      return (
        <Formik
          {...props}
          render={formProps => (
            <div>
              <Effect onChange={onChange} />
              {render({ ...renderProps, ...formProps })}
            </div>
          )}
        />
      )
    }

    return <StatefulForm {...this.props} />
  }
}

export default SOPQFlightFormContainer
